<mat-menu #adminEventMenu="matMenu">
    <button mat-menu-item> Edit Event </button>
    <button mat-menu-item> Verify Scores </button>
    <button mat-menu-item> Event Info </button>
    <button mat-menu-item> Watch Live </button>
    <button mat-menu-item> Results </button>
</mat-menu>
<button mat-icon-button #adminMenuTrigger="matMenuTrigger"  [matMenuTriggerFor]="adminEventMenu">
    <mat-icon>more_vert</mat-icon>
</button>